import {
  BiTitleAlign,
  kBiVizStyleDefaults,
  kBiVizStyleOptionNames,
} from '@euler/model/bi/viz';
import { memo } from 'react';
import { BiChip } from '../../../../components/ui/BiChip';
import { StyleGroup } from '../StyleGroup';
import { StyleRow } from '../StyleRow';
import { biWithStyleOption } from '../functions/biStyleEdit';
import { BiStyleOptionProps } from '../functions/biStyleOptionProps';

/** Whether the card shows its title, and where. */
export const TitleOptions = memo(({ style, onChange }: BiStyleOptionProps) => {
  const title = { ...kBiVizStyleDefaults.title, ...style?.title };
  const set = (patch: Partial<typeof title>) =>
    onChange(biWithStyleOption(style, 'title', { ...title, ...patch }));
  return (
    <StyleGroup
      title={kBiVizStyleOptionNames.title}
      onReset={
        style?.title
          ? () => onChange(biWithStyleOption(style, 'title', undefined))
          : null
      }
    >
      <StyleRow label="显示">
        <BiChip
          label="显示"
          selected={title.show}
          onPress={() => set({ show: true })}
        />
        <BiChip
          label="隐藏"
          selected={!title.show}
          onPress={() => set({ show: false })}
        />
      </StyleRow>
      {title.show ? (
        <StyleRow label="对齐">
          <BiChip
            label="靠左"
            selected={title.align !== BiTitleAlign.Center}
            onPress={() => set({ align: BiTitleAlign.Left })}
          />
          <BiChip
            label="居中"
            selected={title.align === BiTitleAlign.Center}
            onPress={() => set({ align: BiTitleAlign.Center })}
          />
        </StyleRow>
      ) : null}
    </StyleGroup>
  );
});
